import NotificationLogClient, {
	DEFAULT_SOURCE,
	DEFAULT_GRAPHQL_BASE_URL,
} from './NotificationLogClient';

export type { NotificationLogProvider, NotificationCountResponse } from './types';

export { NotificationLogClient, DEFAULT_SOURCE, DEFAULT_GRAPHQL_BASE_URL };
